import { ReplaySubject } from 'rxjs';

import { Injectable } from '@angular/core';
import { GeolocationPosition, GeolocationPositionError } from '@features/stores-overview/model/geolocation';
import { BreakpointService } from '@libs/breakpoints';

@Injectable({
    providedIn: 'root'
})
export class GeoLocationService {
    private currentPostionRs$: ReplaySubject<GeolocationPosition> = new ReplaySubject();

    public currentPosition$ = this.currentPostionRs$.asObservable();

    constructor(private readonly breakpointService: BreakpointService) {}

    public activateGeoLocation(): void {
        if (this.breakpointService.isBrowser() && 'geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(this.onSuccess.bind(this), this.onFail.bind(this));
        } else {
            this.currentPostionRs$.error({ message: 'Geolocation not supported by browser' });
        }
    }

    private onSuccess(geolocationPosition: GeolocationPosition) {
        this.currentPostionRs$.next(geolocationPosition);
    }

    private onFail(geolocationError: GeolocationPositionError) {
        this.currentPostionRs$.error(geolocationError);
    }
}
